import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardTitle, Col, Container, FormGroup, Input, Label, Row } from "reactstrap"
import PropTypes from "prop-types"
// Import Editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

//Import Date Picker
import "react-datepicker/dist/react-datepicker.css"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import {connect} from "react-redux"
import {buscarNotificacao, cadastrarNotificacao, editarNotificacao} from "../../store/auth/profile/actions"
import Loader from "react-loader-spinner"
import ToggleButton from "react-bootstrap/ToggleButton"
import {buscarUsuariosPorEmpresa} from "store/auth/profile/actions"
import usePermission from "helpers/permission/usePermission"
import StickerToolbarButtons from "../../components/Common/sticker-toolbar-buttons";
import { describeDateTime, getCompanies } from "../../helpers/utils"
import {ToggleButtonGroup} from "react-bootstrap";
import FormInputNumber from "../../components/Common/form-input-number";
import FormInputText from "../../components/Common/form-input-text";
import FormSelectCompany from "../../components/Common/form-select-company";
import { useLocation } from "react-router-dom"
import { navegarBreadCrumb } from "../../store/navigator/actions"
import ButtonRedirect from "../../components/Common/button-redirect"
import toastr from "toastr";
import FormInputDate from "../../components/Common/form-input-date";
import FormInputSelect from "../../components/Common/form-input-select";
import {withTranslation} from "react-i18next";
import Tooltip from "../../components/Common/tooltip";
import {EditorState} from "draft-js";
import FormInputEditor from "../../components/Common/form-input-editor";
import {stateToHTML} from "draft-js-export-html";
import {stateFromHTML} from "draft-js-import-html";
import { format } from "date-fns"

const CadastrarNotificacao = props => {

    const [paramIdCloud, setParamIdCloud] = useState(undefined)
    const isInforangraAdmin = props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador
    const [id, setId] = useState()
    const [titulo, setTitulo] = useState()
    const [notificacaoState, setNotificacaoState] = useState(EditorState.createEmpty())
    const [dataEntrega, setDataEntrega] = useState()
    const [status, setStatus] = useState()
    const [empresa, setEmpresa] = useState(null)
    const [usuario, setUsuario] = useState(null)
    const [diasSemAcesso, setDiasSemAcesso] = useState(null)
    const [diasCertificadoVencer, setDiasCertificadoVencer] = useState(null)
    const [usuarioSemVinculo, setUsuarioSemVinculo] = useState(false)
    const [usuarioComVinculo, setUsuarioComVinculo] = useState(false)
    const [usuarioComVinculoPendente, setUsuarioComVinculoPendente] = useState(false)
    const [semCertificado, setSemCertificado] = useState(false)
    const [certificadoDigitalVencido, setCertificadoDigitalVencido] = useState(false)
    const [certificadoDigitalVencimentoProximo, setCertificadoDigitalVencimentoProximo] = useState(false)
    const [notificaBaixaBateria, setNotificaBaixaBateria] = useState(false)
    const [horaEntrega, setHoraEntrega] = useState(new Date())
    const [ultimaAtualizacao, setUltimaAtualizacao] = useState()
    const [percentualBateriaMinima, setPercentualBateriaMinima] = useState()
    const [dispositivosUltimasHoras, setDispositivoUltimasHoras] = useState()

    const [notificaEmail, setNotificaEmail] = useState(true)
    const [notificaSistema, setNotificaSistema] = useState(false)
    const [notificaPush, setNotificaPush] = useState(false)
    const [loaded, setLoaded] = useState(false)

    const [companies, setCompanies] = useState()
    const [usuariosEmpresa, setUsuariosEmpresa] = useState([])

    const usePermissionEdit = usePermission('notificacoesEdit_editar')
    const usePermissionInsert = usePermission('notificacoesEdit_inserir')
    const usePermissionRemove = usePermission('notificacoesEdit_excluir')
    const possuiVinculo = (props.user?.vinculos || []).some(vinculo => ["A", "T"].includes(vinculo.vinculo_status))

    const location = useLocation();

    const getAndSearch = (idCloud)=>{
        props.buscarNotificacao({id: idCloud}, props.history)
        props.navegarBreadCrumb( {title: `breadcrumb.notification`, link: location.pathname, id: idCloud})
    }

    useEffect(() => {
        if (paramIdCloud !== undefined) return

        const idCloud = props.match.params.hasOwnProperty('idCloud') ? props.match.params.idCloud : null
        if (idCloud) {
            getAndSearch(idCloud)
        } else {
            props.navegarBreadCrumb({title: `breadcrumb.notification.new`, link: location.pathname})
        }
        setLoaded(true)
        setParamIdCloud(idCloud)
    }, [props.match.params])


    useEffect(() => {
        const tmpCompanies = getCompanies(props.user)
        setCompanies(tmpCompanies)

        return () => {
            setCompanies([])
        }
    }, [])

    useEffect(() => {
        if (props.notificacao && props.notificacao?.id) {
            preencherFormulario(props.notificacao)
        } else {
            setId(null)
            setDataEntrega(new Date())
            setTitulo(null)
            setStatus('N') //E: ENTREGUE, N: NÃO ENTREGUE
            setNotificacaoState(prevState => EditorState.createEmpty())
            setUsuario(null)
            setDiasCertificadoVencer(null)
            setUsuarioSemVinculo(false)
            setUsuarioComVinculo(false)
            setUsuarioComVinculoPendente(null)
            setNotificaEmail(false)
            setNotificaSistema(false)
            setNotificaPush(false)
            setDiasCertificadoVencer(null)
            setSemCertificado(false)
            setCertificadoDigitalVencido(false)
            setCertificadoDigitalVencimentoProximo(false)
            setNotificaBaixaBateria(false)
            setHoraEntrega(new Date())
        }

    }, [props.notificacao])

    const preencherFormulario = (notificacao) => {
        setId(notificacao.id)
        setTitulo(notificacao.titulo)
        let contentState = stateFromHTML(notificacao.notificacao)
        setNotificacaoState(prevState => EditorState.createWithContent(contentState))
        setDataEntrega(new Date(notificacao.data_entrega))
        setStatus(notificacao.status_entregue) //E: ENTREGUE, N: NÃO ENTREGUE
        alterarEmpresa(notificacao.idEmpresa)
        setUsuario(notificacao.usuario_id)
        setDiasSemAcesso(notificacao.dias_sem_acesso)
        setUsuarioSemVinculo(notificacao.usuario_sem_vinculo)
        setUsuarioComVinculo(notificacao.usuario_com_vinculo)
        setUsuarioComVinculoPendente(notificacao.usuario_com_vinculo_pendente)
        setNotificaEmail(notificacao.notifica_email)
        setNotificaSistema(notificacao.notifica_sistema)
        setNotificaPush(notificacao.notifica_push)
        setDiasCertificadoVencer(notificacao.dias_certificado_vencer)
        setSemCertificado(notificacao.sem_certificado)
        setCertificadoDigitalVencido(notificacao.certificado_digital_vencido)
        setCertificadoDigitalVencimentoProximo(notificacao.certificado_digital_vencimento_proximo)
        setNotificaBaixaBateria(notificacao.notifica_baixa_bateria)
        setUltimaAtualizacao(notificacao.updated_at)
        if (notificacao.hora_entrega) {
            const [hours, minutes, seconds] = notificacao.hora_entrega.split(':');
            const novaHora = new Date()
            novaHora.setHours(Number(hours), Number(minutes), 0, 0)
            setHoraEntrega(novaHora)
        }
        setPercentualBateriaMinima(notificacao.percentual_bateria_minima)
        setDispositivoUltimasHoras(notificacao.dispositivo_ultimas_horas)
    }

    useEffect(() => {
        setUsuariosEmpresa(Array.isArray(props.usuariosEmpresa) ? props.usuariosEmpresa.map(e => ({
            label: e.nome_completo,
            value: e.id
        })) : [])

        return () => setUsuariosEmpresa([])
    }, [props.usuariosEmpresa])

    const gravarNotificacao = (e) => {
        let valid = true
        valid = valid && (!!titulo)
        valid = valid && (!!notificacaoState)

        if (status === 'A') {
            valid = valid && (!!horaEntrega)
        } else {
            valid = valid && (!!dataEntrega)
        }

        if (!isInforangraAdmin && !empresa) {
            valid = false
        }

        if (valid) {
            salvarNotificacao()
        } else {
            const divs = document.getElementsByName("validate-required")
            for (let i = 0; i < divs.length; i++) {
                divs[i].style.display = "block"
            }

            window.scrollTo(0, 0)

            toastr.error('Há campos inválidos no formulário!', 'Validação de informações')
        }
    }

    const salvarNotificacao = () => {
        const estoque = props.estoque ? Object.assign({}, props.estoque) : {}
        estoque.id = id
        estoque.titulo = titulo
        estoque.notificacao = stateToHTML(notificacaoState.getCurrentContent())
        estoque.data_entrega = dataEntrega
        estoque.idEmpresa = empresa ? empresa : null
        estoque.usuario_id = usuario ? usuario : null
        estoque.dias_sem_acesso = diasSemAcesso ? diasSemAcesso : null
        estoque.usuario_sem_vinculo = usuarioSemVinculo
        estoque.usuario_com_vinculo = usuarioComVinculo
        estoque.usuario_com_vinculo_pendente = usuarioComVinculoPendente
        estoque.notifica_email = notificaEmail
        estoque.notifica_sistema = notificaSistema
        estoque.notifica_push = notificaPush
        estoque.dias_certificado_vencer = diasCertificadoVencer ? diasCertificadoVencer : null
        estoque.sem_certificado = semCertificado
        estoque.certificado_digital_vencido = certificadoDigitalVencido
        estoque.certificado_digital_vencimento_proxim = certificadoDigitalVencimentoProximo
        estoque.notifica_baixa_bateria = notificaBaixaBateria
        estoque.status_entregue = status
        if (horaEntrega && status === 'A') {
            estoque.hora_entrega = format(horaEntrega, 'HH:mm')
        } else {
            estoque.hora_entrega = null
        }
        estoque.percentual_bateria_minima = percentualBateriaMinima
        estoque.dispositivo_ultimas_horas = dispositivosUltimasHoras

        if (estoque.id) {
            props.editarNotificacao(estoque, props.history)
        } else {
            props.cadastrarNotificacao(estoque, props.history)
        }
    }

    const alterarEmpresa = value => {
        const empresaId = value ? value : null
        setEmpresa(empresaId)
        alterarUsuario(null)
        if (value) {
            props.buscarUsuariosPorEmpresa({empresaId: value})
        }

    }

    const alterarUsuario = value => {
        setUsuario(value)
    }

    const alteraMotivoNotificacao = value => {
        setUsuarioSemVinculo(false)
        setUsuarioComVinculo(false)
        setUsuarioComVinculoPendente(false)
        setSemCertificado(false)
        setCertificadoDigitalVencido(false)
        setCertificadoDigitalVencimentoProximo(false)
        setNotificaBaixaBateria(false)
        setDiasSemAcesso(0)
        setDiasCertificadoVencer(0)
        setStatus("N")
        setPercentualBateriaMinima(null)
        setDispositivoUltimasHoras(null)

        if (!value) return

        switch (value) {
            case 'usuarioSemVinculo':
                setUsuarioSemVinculo(true);
                break;
            case 'usuarioComVinculo':
                setUsuarioComVinculo(true);
                break;
            case 'usuarioComVinculoPendente':
                setUsuarioComVinculoPendente(true);
                break;
            case 'semCertificado':
                setSemCertificado(true);
                break;
            case 'certificadoDigitalVencido':
                setCertificadoDigitalVencido(true);
                break;
            case 'certificadoDigitalVencimentoProximo':
                setCertificadoDigitalVencimentoProximo(true);
                setStatus("A")
                break;
            case 'notificaBaixaBateria':
                setNotificaBaixaBateria(true);
                setStatus("A")
                setPercentualBateriaMinima(70)
                setDispositivoUltimasHoras(1)
                break;
            default:
                break;
        }
    }

    const alterarTipoNotificacao = value => {
        let notificaEmail = false
        let notificaSistema = false
        let notificaPush = false

        if (value === 'notificaEmail') {
            notificaEmail = true
        } else if (value === 'notificaSistema') {
            notificaSistema = true
        } else if (value === 'notificaPush') {
            notificaPush = true
        }

        setNotificaEmail(notificaEmail)
        setNotificaSistema(notificaSistema)
        setNotificaPush(notificaPush)
    }

    return (
        <>
            {props.notificacaoLoading ? (<div className="loader-container position-absolute">
                <Loader
                    type="ThreeDots"
                    color="#556EE6"
                    height={80}
                    width={80}
                />
            </div>) : (
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="menu.label.notification"/>
                        <StickerToolbarButtons>
                            <ButtonRedirect path={"notificacoes"} history={props.history}></ButtonRedirect>
                            <Button
                                type="submit"
                                color="primary"
                                disabled={status === 'E' || !((id && usePermissionEdit) || (!id && usePermissionInsert))}
                                onClick={e => gravarNotificacao()}>
                                {id ? "Salvar Notificação" : "Cadastrar Notificação"}
                            </Button>
                        </StickerToolbarButtons>
                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody>
                                        <CardTitle className="mb-4">Cadastro</CardTitle>
                                        <form>
                                            <div className="outer">
                                                <div className="outer">

                                                    {id && <FormGroup className="mb-4" row>
                                                        <Label htmlFor="codigo" className="col-form-label col-lg-2">
                                                            Código
                                                        </Label>
                                                        <Col lg="10" className="col-form-label">
                                                            {id}
                                                        </Col>
                                                    </FormGroup>}

                                                    {(!usuario) && (
                                                      <FormGroup className="mb-4" row>
                                                          <Label className="col-form-label col-lg-2">
                                                              {props.t('notificacao.edicao.motivo.label')}
                                                              <Tooltip id="motivo-title"
                                                                       tooltip={props.t('notificacao.edicao.motivo.title')}></Tooltip>
                                                          </Label>
                                                          <Col lg="10">
                                                              <ToggleButtonGroup type="radio" className="mb-0"
                                                                                 name="motivo"
                                                                                 onChange={e => alteraMotivoNotificacao(e)}
                                                                                 value={usuarioSemVinculo ? 'usuarioSemVinculo' :
                                                                                   usuarioComVinculo ? 'usuarioComVinculo' :
                                                                                     usuarioComVinculoPendente ? 'usuarioComVinculoPendente' :
                                                                                       semCertificado ? 'semCertificado' :
                                                                                         certificadoDigitalVencido ? 'certificadoDigitalVencido' :
                                                                                           certificadoDigitalVencimentoProximo ? 'certificadoDigitalVencimentoProximo' :
                                                                                             notificaBaixaBateria ? 'notificaBaixaBateria' : null}>
                                                                  {!empresa && <ToggleButton
                                                                    id="usuarioSemVinculo"
                                                                    variant="outline-primary"
                                                                    value="usuarioSemVinculo">
                                                                      Usuário sem vínculo
                                                                  </ToggleButton>}

                                                                  {empresa && <ToggleButton
                                                                    id="usuarioComVinculo"
                                                                    variant="outline-primary"
                                                                    value="usuarioComVinculo">
                                                                      Usuário com vínculo
                                                                  </ToggleButton>}

                                                                  {empresa && <ToggleButton
                                                                    id="usuarioComVinculoPendente"
                                                                    variant="outline-primary"
                                                                    value="usuarioComVinculoPendente">
                                                                      Usuário com vínculo pendente
                                                                  </ToggleButton>}

                                                                  <ToggleButton
                                                                    id="semCertificado"
                                                                    variant="outline-primary"
                                                                    value="semCertificado">
                                                                      Empresa sem certificado digital
                                                                  </ToggleButton>

                                                                  <ToggleButton
                                                                    id="certificadoDigitalVencido"
                                                                    variant="outline-primary"
                                                                    value="certificadoDigitalVencido">
                                                                      Empresa com certificado digital vencido
                                                                  </ToggleButton>

                                                                  <ToggleButton
                                                                    id="certificadoDigitalVencimentoProximo"
                                                                    variant="outline-primary"
                                                                    value="certificadoDigitalVencimentoProximo">
                                                                      Empresa com certificado digital próximo ao
                                                                      vencimento
                                                                  </ToggleButton>

                                                                  <ToggleButton
                                                                    id="notificaBaixaBateria"
                                                                    variant="outline-primary"
                                                                    value="notificaBaixaBateria">
                                                                      Dispositivo com baixo nível de bateria
                                                                  </ToggleButton>

                                                              </ToggleButtonGroup>
                                                          </Col>
                                                      </FormGroup>
                                                    )}

                                                    <FormSelectCompany
                                                      attribute="empresaId"
                                                      keyTranslate="notificacao.edicao.empresa"
                                                      value={empresa}
                                                      setValue={alterarEmpresa}
                                                      options={companies}
                                                    />


                                                    <FormInputText
                                                        attribute="titulo"
                                                        keyTranslate="notificacao.edicao.titulo"
                                                        value={titulo}
                                                        setValue={setTitulo}
                                                        maxLength={100}
                                                    />


                                                    <FormInputText
                                                        attribute="status"
                                                        keyTranslate="notificacao.edicao.status"
                                                        value={props.t('notificacao.edicao.status.' + status)}
                                                        readonly={true}
                                                        additionalText={ ultimaAtualizacao && status === 'A' ? `Última notificação : ${describeDateTime(ultimaAtualizacao)}`: null}
                                                    />

                                                    <FormInputEditor
                                                        attribute="notificacao"
                                                        keyTranslate="notificacao.edicao.notificacao"
                                                        value={notificacaoState}
                                                        setValue={setNotificacaoState}
                                                    />

                                                    { status === 'A' ?

                                                      <FormInputDate
                                                        attribute="horaEntrega"
                                                        keyTranslate={"notificacao.edicao.horaentrega"}
                                                        value={horaEntrega}
                                                        setValue={setHoraEntrega}
                                                        dateFormat={'HH:mm'}
                                                        withHour={true}
                                                        showTimeSelectOnly={true}
                                                      />
                                                    :
                                                        <FormInputDate
                                                            attribute="dataEntrega"
                                                            keyTranslate={"notificacao.edicao.dataentrega"}
                                                            value={dataEntrega}
                                                            setValue={setDataEntrega}
                                                            dateFormat={'dd/MM/yyyy HH:mm:ss'}
                                                            withHour={true}
                                                        />

                                                    }

                                                    <FormGroup className="mb-4" row>
                                                        <Label className="col-form-label col-lg-2">
                                                            {props.t('notificacao.edicao.tipomotivo.label')}
                                                            <Tooltip id="notificacao"
                                                                     tooltip={props.t('notificacao.edicao.tipomotivo.title')}></Tooltip>
                                                        </Label>
                                                        <Col lg="10">
                                                            <ToggleButtonGroup type="radio" className="mb-2"
                                                                               name="notificacao"
                                                                               onChange={e => alterarTipoNotificacao(e)}
                                                                               value={notificaEmail ? 'notificaEmail' :
                                                                                 notificaSistema ? 'notificaSistema' :
                                                                                   notificaPush ? 'notificaPush' : null}>
                                                                <ToggleButton
                                                                  id="notificaEmail"
                                                                  variant="outline-primary"
                                                                  value="notificaEmail">
                                                                    E-mail
                                                                </ToggleButton>

                                                                <ToggleButton
                                                                  id="notificaSistema"
                                                                  variant="outline-primary"
                                                                  value="notificaSistema">
                                                                    Sistema
                                                                </ToggleButton>

                                                                <ToggleButton
                                                                  id="notificaPush"
                                                                  variant="outline-primary"
                                                                  value="notificaPush">
                                                                    Push Web
                                                                </ToggleButton>

                                                            </ToggleButtonGroup>
                                                        </Col>
                                                    </FormGroup>

                                                    { notificaBaixaBateria && (
                                                      <>
                                                          <FormInputNumber
                                                            attribute="percentualBateriaMinima"
                                                            keyTranslate="notificacao.edicao.percentualBateriaMinima"
                                                            value={percentualBateriaMinima}
                                                            setValue={setPercentualBateriaMinima}
                                                            allowNegative={false}
                                                            max={100}
                                                            min={1}
                                                          />

                                                          <FormInputNumber
                                                            attribute="dispositivosUltimasHoras"
                                                            keyTranslate="notificacao.edicao.dispositivosUltimasHoras"
                                                            value={dispositivosUltimasHoras}
                                                            setValue={setDispositivoUltimasHoras}
                                                            allowNegative={false}
                                                            max={168}
                                                            min={1}
                                                          />
                                                      </>
                                                    )

                                                    }

                                                    {empresa > 0 && (
                                                        <FormInputSelect
                                                            attribute="ippt"
                                                            keyTranslate="notificacao.edicao.usuario"
                                                            value={usuario}
                                                            setValue={alterarUsuario}
                                                            options={usuariosEmpresa}
                                                        />
                                                    )}

                                                    {(usuario || usuarioSemVinculo || usuarioComVinculo || usuarioComVinculoPendente) &&
                                                        <FormInputNumber
                                                            attribute="diasSemAcesso"
                                                            keyTranslate="notificacao.edicao.diasacesso"
                                                            value={diasSemAcesso}
                                                            setValue={setDiasSemAcesso}
                                                            allowNegative={false}
                                                            max={365}
                                                            min={0}
                                                        />
                                                    }

                                                    {(certificadoDigitalVencimentoProximo) &&
                                                        <FormInputNumber
                                                            attribute="diasCertificadoVencer"
                                                            description="Dias para vencer o certificado digital"
                                                            keyTranslate="notificacao.edicao.diascertificadovencer"
                                                            value={diasCertificadoVencer}
                                                            setValue={setDiasCertificadoVencer}
                                                            allowNegative={false}
                                                            max={365}
                                                            min={0}
                                                        />
                                                    }

                                                </div>
                                            </div>
                                        </form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )}
        </>
    )
}

const mapStatetoProps = state => {
    const {notificacaoAtivo, notificacao, notificacaoLoading, usuariosEmpresa, usuariosEmpresaLoading} = state.Profile
    const {user} = state.Login
    return {user, notificacaoAtivo, notificacao, notificacaoLoading, usuariosEmpresa, usuariosEmpresaLoading}
}

export default withTranslation()(connect(mapStatetoProps, {
    buscarNotificacao,
    cadastrarNotificacao,
    editarNotificacao,
    buscarUsuariosPorEmpresa,
    navegarBreadCrumb
})(CadastrarNotificacao))
